module.exports = __webpack_public_path__ + "c232e5361e7f1140151e92281b703ed0.png";